import { Type } from 'class-transformer';
import { NotificationPriority } from './notification-priority.enum';

export class Notification {
  id: number;
  userId: number;
  title: string;
  message: string;
  read: boolean;
  link?: string;
  relativeLink?: string;
  priority: NotificationPriority;
  category: string;
  extras?: Record<string, any>;

  @Type(() => Date)
  createdAt: Date;

  constructor(partial: Partial<Notification> = {}) {
    Object.assign(this, partial);
  }
}
